import * as types from './types';

const defaultState = {
  pending: false,
  response: null,
  success: false,
};

const reducer = (state = defaultState, action) => {
  switch(action.type) {
    case types.DOWNLOAD_FILE_PENDING:
      return {
        ...defaultState,
        pending: true,
      };
    case types.DOWNLOAD_FILE_SUCCESS:
      const { response } = action;
      return {
        ...defaultState,
        response,
        pending: false,
        success: true,
      };
    case types.DOWNLOAD_FILE_ERROR:
      return {
        ...defaultState,
        pending: false,
        success: false,
      };
    case types.DOWNLOAD_FILE_RESET:
      return { ...defaultState };
    default:
      return state;
  }
};

// Reducer
export default reducer;
